import $ from 'jquery';
window.jQuery = window.$ = $;

import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';

import tempNav from './functions/tempNav';
import lazyBGImageInit from './functions/lazy';
import warriorJs from './functions/warrior';
import slider404 from './functions/404Slider';
import newsLanding from './functions/newsLanding';
import programsLanding from './functions/programsLanding';
import winterSnow from './functions/winterSnow';
import onlineReturns from './functions/onlineReturns';
import shelterPageSlider from './functions/shelterPageSlider';
import tagFilters from './functions/tagFilters';
import trioSlider from './functions/trioSlider';
import mobileNav from './functions/mobileNav';
import search from './functions/search';
import splitHeroText from './functions/splitHeroText';
import formReferrer from './functions/formReferrer';
import innovation from './functions/innovation';
import gallery from './functions/gallery';
import megaNavDesk from './functions/megaNavDesk';
import subnav from './functions/subnav';
import reviewsModSlider from './functions/reviewsSlider';
import imageShowMod from './functions/imageShow';
import notificationAdjustments from './functions/notificationBar';
import homeHeroArrow from './functions/homeHeroArrow';
import pauseVimeoOutOfViewport from './functions/pauseVimeoOutOfViewport';

// Gallery
const galleryModule = $('.gridMod__cont');
const galleryAbout = $('.aboutGallery__imgWrapper');

if (galleryModule.length > 0 || galleryAbout.length > 0) {
	gallery();
}

// notification bar at the top of the page
notificationAdjustments();

// mega menu
megaNavDesk();

// Controls temporary drop nav
tempNav();

// Lazysizes/Lazyloading
lazyBGImageInit();

// Search
search();

// homepage hero arrow to jump page down
homeHeroArrow();

// homeAboutModule - reviews
reviewsModSlider();

// homeAboutModule - reviews imageShow
imageShowMod();

// MobileNav Functions
mobileNav();

// 404 page slider
slider404();

// subnav mobile open/close
subnav();

// innovation
splitHeroText();

// News Landing page
const newsEl = document.getElementsByClassName('all-news-padding');
if (newsEl.length > 0) {
	newsLanding();
}

// Programs Landing page
const programsEl = document.getElementsByClassName('all-progs-padding');
if (programsEl.length > 0) {
	programsLanding();
}

// Warrior Page
const warriorIntro = document.getElementsByClassName('warrior-intro');
if (warriorIntro.length > 0) {
	warriorJs();
}

//  Shelters Page Sliders
const pagesliderCheck = document.getElementsByClassName('page-slider');
if (pagesliderCheck.length > 0) {
	shelterPageSlider();
}

// /Winter - snow for the hero
const winterPageEl = document.getElementsByClassName('winter-hero-container');
if (winterPageEl.length > 0) {
	winterSnow();
}

// innovation particle animation
const innovationEl = document.getElementsByClassName('innovation-hero');
if (innovationEl.length > 0) {
	innovation();
}

//  /News and /Events Filters
const tagEl = document.getElementsByClassName('tagBox');
if (tagEl.length > 0) {
	tagFilters();
}

// Services - Three Image Slider on Hompage and Services
const trioSlide = document.getElementsByClassName('trio-slide');
const trioSlider2 = document.getElementsByClassName('threeSlides');

if (trioSlide.length > 0 || trioSlider2.length > 0) {
	trioSlider();
}

// add the referer page(previous url) to a hidden input field in the form for tracking users
const onlineEl = document.getElementsByClassName('olr-container');
if (onlineEl.length > 0) {
	onlineReturns();
}

// pauseVimeoOutOfViewport does what it's named'
const videoElement = document.querySelector('.missCom__vid');
if (videoElement) {
	pauseVimeoOutOfViewport();
}

// Forms use this for the reference url
formReferrer();
